import React from 'react';
import { RotateCcw } from 'lucide-react';

/**
 * Collapsible "Selecionar Colunas Visíveis" panel.
 * Props:
 *  - columns: [{id, label, fixed?}]
 *  - visible: Set<string>
 *  - onToggle: (id) => void
 *  - onReset: () => void
 */
export default function ColumnsPanel({ columns, visible, onToggle, onReset }) {
  return (
    <div className="card p-5 space-y-4" data-testid="columns-panel">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-200">Selecionar Colunas Visíveis</h3>
        <button onClick={onReset} data-testid="columns-reset"
          className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400">
          <RotateCcw className="w-3.5 h-3.5" /> Restaurar padrão
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {columns.map((col) => {
          const checked = visible.has(col.id);
          const disabled = !!col.fixed;
          return (
            <label key={col.id}
              data-testid={`column-toggle-${col.id}`}
              className={`flex items-center gap-2 ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}>
              <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={() => onToggle(col.id)}
                className="w-4 h-4 rounded accent-indigo-600"
              />
              <span className="text-sm text-slate-700 dark:text-slate-200">{col.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
